import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { Link } from 'react-router'
import EventEmitter from '../../../../utils/events'

// Action
import { updateOrderList, updateOrderListSingle, getOrderSimple, getOrdersNew, moveOrder, UpdateEconomicMatch, updateRekvNumber, startOrder, stopOrder, clearLastVisitedOrderId } from '../../../../actions/orders'
// import { approveOrderInvoice } from '../../../../actions/invoicing'
import { getOrderDataNew } from '../../../../actions/assign'
import { triggerPopup } from '../../../../actions/backdrop'
import { GetSimpleCarRentals } from '../../../../actions/shops'

// Utils
import { translation, enumtranslate } from '../../../../utils/helpers'

// import components
import DateChangePopup from '../../../../shared/components/DateChangePopup'
import DateActions from '../../../../shared/components/DateChangePopup/DateActions'
import OrderActions from '../../../../shared/components/ActionMenu/OrderActions'
import Overlay from '../../../../shared/components/Overlay'
import HoverExtent from '../../../../shared/components/HoverExtent'
import QualityCheckModal from '../../../../shared/modals/QualityCheckModal'
import HoverPopup from '../../../../shared/components/HoverPopup'
import AssignBox from '../../../NewWorkscreen/AssignBox'
import InvoicePopup from '../../../../shared/components/InvoicePopup'
import Popup from './Circle/popup.js'
import StopOtherOrders from '../../../../shared/components/StopOtherOrders'
import Portal from '../../../../shared/components/Portal'

// Overlays
import Notes from './Notes'
import Color from './Color'
// import Invoice from './Invoice'
import InvoiceLog from './InvoiceLog'
import Transport from './Transport'
import PriceChange from './PriceChange'
import ChangeRekvNumber from './RekvNumber'
import SetCustomer from './SetCustomer'

// Taksering
import Taksering from './Taksering'

// Circle
import Circle from './Circle'

// import modals
import ReferenceOrderActionModal from '../../../../shared/modals/ReferenceOrderActionModal'

// import utils
import { renderTime, renderFullDate } from '../../../../utils/time'
import { formatCurrency } from '../../../../utils/currency'
import { makeOrderTitle, makeOrderTypeImage } from '../../../../utils/order'
import { hasAccess, hasSubscriptionPermission, hasAccessToAssign, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { DracarAllowOrderTypes } from '../../../../constants'

// Elements
import Label from '../../../../shared/elements/label'
import HelpIcon from '../../../../shared/elements/helpIcon'

// Styles
import './index.scss'
import { GeneralIcons } from '../../../../shared/elements/icons'
import Grid from '../../../../shared/elements/grid'

class NewItem extends Component {

  constructor (props) {
    super(props)
    this.state = {
      item: null,
      assign_open: false,
      OrderIds: [],
      UserIds: [],
      orderReferenceApprove: {
        open: false,
        id: 0
      },
      MoveOrders: {
        open: false,
        MoveAll: null,
        OrderIds: [],
        FromStep: 0,
        ToStep: 0,
        step: 0,
        index: 0,
        Id: 0
      },
      stopped: {
        open: false,
        comment: ''
      },
      stopOtherOrders: {
        open: false,
        WorkOnAll: null
      },
      stopOrders: {
        open: false,
        StopAll: null
      },
      showTxt: false,
      quality: {
        open: false,
        data: [{}],
        pos: 0,
        index: 0,
        move: true
      },
      showSpinner: {
        invoicing: false
      },
      isIExplorer: false,
      isEdge: false,
      isFireFox: false
    }
    this.updateOrder = this.updateOrder.bind(this)
    this.openAssign = this.openAssign.bind(this)
    this.getAssignOrderData = this.getAssignOrderData.bind(this)
    this.onAssignUsers = this.onAssignUsers.bind(this)
    this.closeAssignBox = this.closeAssignBox.bind(this)
    this.unlockOrder = this.unlockOrder.bind(this)
    this.renderNewOrder = this.renderNewOrder.bind(this)
    // this.approveForInvoice = this.approveForInvoice.bind(this)
    this.closeQualityModal = this.closeQualityModal.bind(this)
    this.moveOrder = this.moveOrder.bind(this)
    this.showSpinner = this.showSpinner.bind(this)
    this.renderWorkproviderPriceMatch = this.renderWorkproviderPriceMatch.bind(this)
    this.renderPaintBodyStatus = this.renderPaintBodyStatus.bind(this)
    this.renderSetNewCustomer = this.renderSetNewCustomer.bind(this)
    this.getVerticalScrollOffset = this.getVerticalScrollOffset.bind(this)
    this.getHorizontalScrollOffset = this.getHorizontalScrollOffset.bind(this)
    this.renderReferred = this.renderReferred.bind(this)
    this.renderItem = this.renderItem.bind(this)
    this.renderLinkedItem = this.renderLinkedItem.bind(this)
    this.triggerClickAssign = this.triggerClickAssign.bind(this)
    this.startOrder = this.startOrder.bind(this)
    this.stopOrder = this.stopOrder.bind(this)
    this.startOrderSuccess = this.startOrderSuccess.bind(this)
    this.moveOrders = this.moveOrders.bind(this)
    this.setStopped = this.setStopped.bind(this)
    this.togglePortal = this.togglePortal.bind(this)
  }

  componentDidMount () {
    this.setState({
      item: this.props.item
    })
    if (!hasAccess([4], this.props.auth.user.UserType)) {
      EventEmitter.addListener('OPEN_ASSIGNBOX', this.closeAssignBox, this)
    }
    this.showSpinner('invoicing', this.props.isInvoicing)

    this.setState({
      isIExplorer: navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1,
      isEdge: navigator.userAgent.indexOf('Edge') > -1,
      isFireFox: navigator.userAgent.indexOf('Firefox') > -1
    })
  }

  componentWillUnmount () {
    if (!hasAccess([4], this.props.auth.user.UserType)) {
      EventEmitter.removeListener('OPEN_ASSIGNBOX', this.closeAssignBox)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(nextProps.item, this.props.item) || this.props.openStartStopId !== nextProps.openStartStopId) {
      this.setState({
        item: nextProps.item
      })
    }

    this.showSpinner('invoicing', nextProps.isInvoicing)
  }

  togglePortal (e) {
    e.preventDefault()
    this.setState({
      stopped: {
        ...this.state.stopped,
        open: false
      }
    })
    document.removeEventListener('click', this.togglePortal, false)
  }

  showSpinner (element, enabled) {
    let spinner = this.state.showSpinner
    spinner[element] = enabled
    this.setState({
      showSpinner: spinner
    })
  }

  closeAssignBox () {
    if (this.state.assign_open !== false) {
      this.setState({
        assign_open: false
      })
    }
  }

  triggerClickAssign () {
    // if (this.props.auth.departmentType === 1) return null // BodyShop should not have this yet...

    let type = !this.state.assign_open
    this.openAssign(type)
    let { item } = this.state
    let element = document.getElementById('' + item.Id)

    if (type) {
      let bounding = element.getBoundingClientRect()
      let distance = (window.innerHeight - 190) - (bounding.top + bounding.height)
      if (distance < 0) {
        let app = document.getElementById('app')
        distance = distance * -1
        element.style.marginBottom = distance + 'px'
        distance += app.scrollTop
        app.scrollTop = distance
      }
    } else {
      element.style.marginBottom = '0px'
    }

    // if (this.props.checkForPopups !== undefined) {
    //   this.props.checkForPopups()
    // }
  }

  renderTime (time, isPickup) {
    if (this.props.auth.user.WorkProviderId + '' === '-1' && this.props.auth.user.CustomerId + '' === '-1' && isPickup && this.props.auth.shopUseTimeForPickupOnOrderList === false) {
      return renderFullDate(time, false)
    } else if (this.props.auth.user.CustomerId === '-1') {
      return renderTime(time)
    } else {
      return renderFullDate(time)
    }
  }

  // Check permissions for this function?
  renderNewOrder () {
    const convertDateOutput = (item, className, translationText) => {
      let newDate = renderFullDate(item)
      let dasDate = newDate.substring(0, 5)
      let dasTime = newDate.substring(12, 18)
      return (
        <span className={className} aria-label={translationText}>
          {dasDate}&nbsp;&nbsp;&nbsp;{dasTime}
        </span>
      )
    }

    // Order inspection
    if (this.state.item.StepId !== 1 && !hasAccess([4], this.props.auth.user.UserType)) {
      let backgroundClass = ''
      if (this.props.auth.departmentType === 1 && this.state.item.Step === 105) {
        let className = ''
        let translationText = ''
        if (this.state.item.IsDeliveryDateChanged) {
          translationText = translation('1273')
          className = 'deliveryChanged'
        }
        return (
          <div className={'times'}>
            {convertDateOutput(this.state.item.Delivery, className, translationText)}
          </div>
        )
        // } else {
        //   return (
        //     <div className={'times'} />
        //   )
        // }
      } else if (!this.state.item.IsReferredOut || [7, 8].includes(this.state.item.Step)) {
        if (hasSubscriptionPermission(this.props.auth, 20) && this.state.item.InspectionStepsCompleted === 0) {
          backgroundClass = 'hasRedBorder'
        }
        if (hasSubscriptionPermission(this.props.auth, 20) && this.state.item.InspectionStepsCompleted !== 0 && this.state.item.InspectionStepsCompleted !== this.state.item.InspectionStepsTotal) {
          backgroundClass = 'hasYellowBorder'
        }
        let timesData = hasSubscriptionPermission(this.props.auth, 10, 0) ? this.state.item.InspectionStepsCompleted + '/' + this.state.item.InspectionStepsTotal : '\u00a0'
        let onClick = () => {
          if (hasSubscriptionPermission(this.props.auth, 10, 30) || hasAccess([6], this.props.auth.user.UserType)) {
            this.props.router.push('/orders/' + this.state.item.Id + '/orderinspection')
          }
        }
        if (!hasSubscriptionPermission(this.props.auth, 20, 0)) backgroundClass = ''
        return (
          <div className={'times hasCursor ' + backgroundClass} onClick={onClick}>
            <Link>
              <img src='/images/svgs/listheader/Inspectionsteps-black.svg' />
              {timesData}
            </Link>
          </div>
        )
      }
    }

    let classList = ''
    if (hasAccess([4], this.props.auth.user.UserType) && !this.state.item.IsDraft) {
      classList = ' hint--top'
    }

    // New order pickup date

    if (this.props.auth.departmentType === 1) {
      return (
        <div className='times mobileTimes'>
          <img src='/images/svgs/listheader/pick-up-time.svg' />
          {hasSubscriptionPermission(this.props.auth, 10) && (<span className={'mobileTime hint--top' + classList} aria-label={translation('157') + ' ' + renderFullDate(this.state.item.BodyShopPickupTime)}>
            {this.renderTime(this.state.item.BodyShopPickupTime, true)}
          </span>)}
        </div>
      )
    } else {
      return (
        <div className='times mobileTimes'>
          <img src='/images/svgs/listheader/pick-up-time.svg' />
          {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && (<span className={'mobileTime hint--top' + classList} aria-label={translation('157') + ' ' + renderFullDate(this.state.item.Pickup)}>
            {this.renderTime(this.state.item.Pickup, true)}
          </span>)}
        </div>
      )
    }
  }

  // should be able to edit Delivery time
  renderHandover (item) {
    if (!item) item = this.state.item
    let classList = 'hint--top'
    let hasCursor = ' hasCursor'
    let translationText = translation('193')
    let showBodyTime = this.props.auth.departmentType === 1 || (this.props.auth.departmentType !== 0 && item.IsBodyShopOrder)
    if (showBodyTime && !hasSubscriptionPermission(this.props.auth, 0) || !showBodyTime && !hasSubscriptionPermission(this.props.auth, 0) && !hasPartnerSubscriptionPermission(this.props.auth, 0)) {
      hasCursor = ' hasDefaultCursor'
    }
    if (!showBodyTime && item.IsDeliveryDateChanged) {
      classList += ' deliveryChanged'
      translationText = translation('1273')
    }
    if (item.StepId === 8 || hasAccess([4], this.props.auth.user.UserType)) {
      hasCursor = ' hasDefaultCursor'
    }
    if (/* this.state.item.StepId >= 7 && */ !item.IsDeliveryDateChanged && !hasAccess([4], this.props.auth.user.UserType)) {
      translationText = translation('193')
      if (item.StepId >= 7) {
        translationText = translation('12')
      }
      translationText += ' ' + renderFullDate(showBodyTime ? item.BodyShopDeliveryTime : item.Delivery)
    }
    let renderTime = () => {
      let iswp = hasAccess([6], this.props.auth.user.UserType)
      let showDateAndTime = !iswp
      if (/* this.state.item.StepId >= 7 && */ !hasAccess([4], this.props.auth.user.UserType)) return renderFullDate(showBodyTime ? item.BodyShopDeliveryTime : item.Delivery, showDateAndTime)
      return this.renderTime(showBodyTime ? item.BodyShopDeliveryTime : item.Delivery)
    }
    if (!item.IsDraft && hasAccess([4], this.props.auth.user.UserType)) {
      classList += ' mobileTime'
      return (
        <div className='times'>
          {item.Delivery && <img src='/images/svgs/listheader/Handsover-New.svg' />}
          {(hasSubscriptionPermission(this.props.auth, 0) || !showBodyTime && hasPartnerSubscriptionPermission(this.props.auth, 0)) && (<span className={classList + hasCursor} aria-label={translationText}>
            {renderTime()}
          </span>)}
        </div>
      )
    }

    let canChange = hasSubscriptionPermission(this.props.auth, 10, 13) || item.StepId === 8
    const renderActionOpener = (opener) => {
      const onClick = e => {
        e.preventDefault()
        this.props.clearLastVisitedOrderId()
        opener(e)
      }

      classList += ' mobileTime'
      return (
        <div className={canChange ? 'hasCursor' : ''} onClick={onClick}>
          <img src='/images/svgs/listheader/Handsover-New.svg' />
          {(hasSubscriptionPermission(this.props.auth, 10) || !showBodyTime && hasPartnerSubscriptionPermission(this.props.auth, 10)) && (<span className={classList + hasCursor} aria-label={translationText}>{renderTime()}</span>)}
        </div>
      )
    }
    const renderActionMenu = (triggerOpen) => {
      if (!canChange) return null
      return (
        <DateActions item={item} orderId={item.Id} location='orderlist' onSuccess={triggerOpen} />
      )
    }
    return <DateChangePopup selfClick className={() => 'datechangepopup times' + hasCursor} renderActionOpener={renderActionOpener} renderActionMenu={renderActionMenu} />
  }

  deleteOrderIndex (step, index) {
    // For some reason the IsDeleted flag is not always set, this should fix that.
    if (this.state.item !== undefined && this.state.item !== null && !this.state.item.IsDeleted) {
      this.setState({
        item: {
          ...this.state.item,
          IsDeleted: true
        }
      })
    }
  }

  // approveForInvoice (undo) {
  //   this.props.approveOrderInvoice(this.state.item.Id, undo).then((res) => {
  //     let item = { ...this.state.item }
  //     item.ReadyForInvoice = res.data.ReadyForInvoice
  //     this.updateOrder(item)
  //   })
  // }
// <div className='divider' key='1' />,
  renderInvoice (invoiceItem) {
    let isDuplicate = invoiceItem.OrderKey !== undefined && invoiceItem.OrderKey !== null && invoiceItem.OrderKey.endsWith('_LoosePart')
    if (isDuplicate) {
      return (<div className='invoice' key='2' />)
    }
    // console.log('invoice item ', invoiceItem)
    // Default not ready for invoice
    if (invoiceItem.IsDraft || invoiceItem.IsWrecked) {
      let setCustomer = this.renderSetNewCustomer(invoiceItem)
      return ([
        !invoiceItem.IsWrecked && <div className='divider' key='1' />,
        <div className='invoice' key='2'>
          {setCustomer !== null ? setCustomer : (<span className='icon' />)}
        </div>
      ])
    }
    if (!hasSubscriptionPermission(this.props.auth, 10)) {
      return ([
        <div className='divider' key='1' />,
        <div className='invoice noclick' key='2' />
      ])
    }
    if (this.state.showSpinner.invoicing === true) {
      return ([
        <div className='divider' key='1' />,
        <div className='invoice' key='2'>
          <span className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
          </span>
        </div>
      ])
    }

    // Do not allow invoicing referred out orders
    if (invoiceItem.IsReferredOut && invoiceItem.OrderConnection !== undefined && invoiceItem.OrderConnection !== null) {
      if (invoiceItem.OrderConnection.MoveType !== undefined && invoiceItem.OrderConnection.MoveType !== null && invoiceItem.OrderConnection.MoveType === 1) {
        let referredName = invoiceItem.OrderConnection.TransferedToCompanyName
        if (invoiceItem.OrderConnection.TransferedToCompanyName === undefined || invoiceItem.OrderConnection.TransferedToCompanyName === null) {
          referredName = ''
        }
        let referText = translation('729') + ' ' + referredName
        return (
          <div className='invoice' key='2'>
            <HelpIcon altIcon={GeneralIcons.Info_Circle_Grey} helpText={referText} size='s' />
          </div>
        )
      }
    }
    let iswp = hasAccess([6], this.props.auth.user.UserType)
    let image = 'Total_price.svg'
    let showBubbleText = translation('13509')

    // Ready for invoice
    if ((!iswp && invoiceItem.ReadyForInvoice + '' === '1') || (iswp && invoiceItem.ReadyForInvoiceByWP)) {
      image = 'ready-for-invoice.svg'
      showBubbleText = translation('1139')

      // Invoice status reset
      if (invoiceItem.InvoiceStatusIsResat) { // if it is resat and approved
        image = 'approved-for-invoicing_reset.svg'
        showBubbleText = translation('15003')
      }
    } else {
      // Invoice status reset
      if (invoiceItem.InvoiceStatusIsResat) { // if it is resat and not approved
        image = 'reset-invoising.svg'
        showBubbleText = translation('15006')
      }
    }
    if (invoiceItem.IsMarkInvoiced) { // (!iswp && invoiceItem.IsMarkInvoiced) || (iswp && invoiceItem.IsMarkInvoicedByWP)) {
      image = 'billed-not-posted.svg'
      showBubbleText = translation('13510')
    }
    if (invoiceItem.IsInvoiced && !invoiceItem.IsMarkInvoiced) { // (!iswp && invoiceItem.IsInvoiced && !invoiceItem.IsMarkInvoiced) || (iswp && invoiceItem.IsInvoicedByWP && !invoiceItem.IsMarkInvoicedByWP)) {
      image = 'posted-not-billed.svg'
      showBubbleText = translation('13511')
    }
    if (invoiceItem.HasInvoiceError) {
      image = 'ready-for-invoice_notication.svg'

      switch (invoiceItem.InvoiceError) {
        case 0:
          showBubbleText = `${translation('1139')} – ${translation('13700')}`
          break
        case 1:// OrderNotFound = 1,
          showBubbleText = `${translation('1139')} – ${translation('13701')}`
          break
        case 2:// CompanyNotFound = 2,
          showBubbleText = `${translation('1139')} – ${translation('13702')}`
          break
        case 3:// NotValidEconomicCredentials = 3,
          showBubbleText = `${translation('1139')} – ${translation('13703')}`
          break
        case 4:// NotValidHeliosNumber = 4,
          showBubbleText = `${translation('1139')} – ${translation('13704')}`
          break
        case 5:// NotValidC5UserPass = 5,
          showBubbleText = `${translation('1139')} – ${translation('13705')}`
          break
        case 6:// OrderIsAlreadySent = 6,
          showBubbleText = `${translation('1139')} – ${translation('13706')}`
          break
        case 7:
          showBubbleText = `${translation('1139')} – ${translation('13707')}`
          break
        case 8:// AwaitingPriceApproval = 8
          showBubbleText = `${translation('1139')} – ${translation('2710')}`
          break
        case 9:
          showBubbleText = `${translation('1139')} – ${translation('14851')}`
          break
        default:
          showBubbleText = translation('1139')
      }
    }

    // Is invoiced and marked
    if (invoiceItem.IsInvoiced && invoiceItem.IsMarkInvoiced && !invoiceItem.InvoiceStatusIsResat) { // (!iswp && invoiceItem.IsInvoiced && invoiceItem.IsMarkInvoiced) || (iswp && invoiceItem.IsInvoicedByWP && invoiceItem.IsMarkInvoicedByWP)) {
      image = 'Payment-ok.svg'
      showBubbleText = translation('13512')
      // Return
      return ([
        <div className='invoice' key='2'>
          <div className='hint--left' aria-label={showBubbleText}>
            <img src={'/images/svgs/invoice/' + image} className='icon' />
          </div>
        </div>
      ])
    }

    const stoppedOnClick = (message) => {
      window.toastr.error(message, translation('216'))
    }

    let dracarSettings

    // Should be moved to backend, when invoice component gets reworked
    if (this.props.auth.permissions.DracarUsable) {
      dracarSettings = {
        dracarNonMatchesFound: invoiceItem.DracarNonMatchingPartsExists,
        dracarOrderSet: invoiceItem.DracarRepairOrderSet,
        dracarActive: this.props.auth.permissions.DracarAllowed,
        isDracarOtherOrder: !DracarAllowOrderTypes.includes(invoiceItem.OrderType), // other orderType order when using Dracar
        isRpReport: invoiceItem.ReportType === 2
      }
    }

    // Overlay
    let renderActionMenu = (close) => {
      return <InvoicePopup
        item={invoiceItem}
        updateOrder={this.updateOrder}
        close={close}
        showSpinner={this.showSpinner}
        dracarSettings={dracarSettings} />
    }
    let renderActionOpener = (opener) => {
      let openerAction = opener
      if (!hasSubscriptionPermission(this.props.auth, 10, [6, 30]) || !hasSubscriptionPermission(this.props.auth, 10, 30) && !((!iswp && invoiceItem.ReadyForInvoice + '' === '1') || (iswp && invoiceItem.ReadyForInvoiceByWP))) {
        openerAction = () => {}
      }
      if (invoiceItem.IsStopped) {
        const errorMsg = translation('15041') + ': ' + invoiceItem.StoppedMessage
        openerAction = stoppedOnClick.bind(this, errorMsg)
      }

      const onClick = e => {
        this.props.clearLastVisitedOrderId()
        openerAction(e)
      }

      return ([
        <div className='invoice' key='2'>
          <div className='hint--left' aria-label={showBubbleText}>
            <img src={'/images/svgs/invoice/' + image} className='icon hasCursor' onClick={onClick} />
          </div>
        </div>
      ])
    }
    return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} checkForPopups={this.props.checkForPopups} />
  }

  renderShowInvoice (invoiceitem) {
    let shownData = ''
    // let shownData2 = ''
    let MyClassNames = ''
    // let dasLink = '/orders/' + invoiceitem.Id
    if (invoiceitem.RekvNumber) {
      shownData = invoiceitem.RekvNumber
      MyClassNames = 'iconNumber'
      if (shownData.length > 7) {
        // shownData2 = shownData.substring(0, 7) + '...'
      }
    } else {
      shownData = translation('13024')
      // MyClassNames = 'iconNumber fadeIconNumber'
    }

    // Overlay
    let renderActionMenu = () => {
      return <ChangeRekvNumber id={invoiceitem.Id} item={invoiceitem} updateOrder={this.updateOrder} />
    }
    let renderActionOpener = (opener) => {
      const onClick = e => {
        this.props.clearLastVisitedOrderId()
        opener(e)
      }
      return (
        <div className='reknumber hint--right' key='2' aria-label={shownData}>
          <span className={MyClassNames} onClick={onClick}>
            <img src='/images/svgs/ordrer/Requisition_No.svg' /></span>
        </div>
      )
    }
    return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} key={Math.random()} checkForPopups={this.props.checkForPopups} />
  }

  renderSetNewCustomer (item) {
    const { allowNoCustomer } = this.props.auth

    if (
      item.CustomerSelect !== 1 ||
      item.OrderDepartment === 0 ||
      (item.ForsiReportId === null && !allowNoCustomer) ||
      (item.ForsiReportId === '' && !allowNoCustomer)
    ) {
      return null
    }
    if (this.props.auth.departmentType !== 1) return null

    // Overlay
    let renderActionMenu = (close) => {
      return <SetCustomer id={item.Id} item={item} updateOrder={this.updateOrder} close={close} />
    }
    let renderActionOpener = (opener) => {
      const onClick = e => {
        this.props.clearLastVisitedOrderId()
        opener(e)
      }
      let image = '/images/svgs/stop-customer.svg'
      return (
        <div className='hint--left' aria-label={translation('2259')}>
          <span className={''} onClick={onClick}><img src={image} className='icon hasCursor' /></span>
        </div>
      )
    }
    return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} key={Math.random()} checkForPopups={this.props.checkForPopups} />
  }

  renderNotes (noteItem) {
    let icon
    // if order does not have notes from customer or shop
    if (!hasSubscriptionPermission(this.props.auth, 0) || !noteItem.HasNotes) return <div className='icon' />
    // if order has unread notes
    if (noteItem.UnreadNotes !== 0) {
      let browserClass = ''
      if (this.state.isFireFox) {
        browserClass = ' FireFox'
      } else if (this.state.isEdge) {
        browserClass = ' Edge'
      } else if (this.state.isIExplorer) {
        browserClass = ' IExplorer'
      }

      // Should trigger popup when clicked on
      icon = (
        <span className='hasTextInBubble hasTextInBubbleNotes'>
          <div className='hint--left' aria-label={translation('2339')}>
            <img src='/images/svgs/comment/comment-red-circle.svg' className='icon hasCursor' />
          </div>
          <span className={browserClass}>{noteItem.UnreadNotes}</span>
        </span>
      )
    } else {
      // Default
      icon = (
        <div className='hint--left' aria-label={translation('149')}>
          <img src='/images/svgs/comment/comment-new.svg' className='icon hasCursor' />
        </div>
      )
    }

    // Overlay
    let renderActionMenu = () => {
      return <Notes id={noteItem.Id} updateOrder={this.updateOrder} checkForPopups={this.props.checkForPopups} />
    }
    let renderActionOpener = (opener) => {
      const onClick = (e) => {
        this.props.clearLastVisitedOrderId()
        opener(e)
      }
      return (
        <span onClick={onClick}>
          {icon}
        </span>
      )
    }
    let openClick = (open) => {
      /*       if (open) {
              if (!noteItem.isLinkMain && noteItem.LinkedOrders.length === 0 && this.state.item.LinkedOrders.length > 0) {
                this.state.item.LinkedOrders.filter(e => noteItem.Id === e.Id)[0].UnreadNotes = 0
              } else {
                this.setState({
                  item: {
                    ...this.state.item,
                    UnreadNotes: 0
                  }
                })
              }
              this.updateOrder(this.state.item)
            } */
    }
    return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} openClick={openClick} checkForPopups={this.props.checkForPopups} />
  }

  renderMissingPart (partItem) {
    let icon
    if (!partItem.MissingParts) return <div className='icon' />
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    let message = translation('13520')
    if (partItem.MissingPartsMessage) {
      message += ':\n' + partItem.MissingPartsMessage
    }
    const onClick = () => {
      if (isCustomer) {
        this.setState({
          showTxt: !this.state.showTxt
        })
        return null
      }
      this.props.router.push('/orders/' + partItem.Id + '/orderinspection')
    }

    const popup = () => {
      if (isCustomer !== true || this.state.showTxt === false || !partItem.MissingPartsMessage) return null
      console.log('partItem.MissingPartsMessage: ', partItem.MissingPartsMessage)
      return (
        <div className='poppedup padding InfoPopup'>
          <label>{partItem.MissingPartsMessage}</label>
        </div>
      )
    }

    let cName = 'icon missingparticon ' + ((isCustomer && !partItem.MissingPartsMessage) ? '' : 'hasCursor')
    icon = (
      <div className='hint--left' aria-label={message}>
        <img src='/images/svgs/missing-parts/missing-parts.svg' className={cName} onClick={onClick} />
        {popup()}
      </div>
    )
    // Overlay
    let renderActionMenu = () => {
      return <Notes id={partItem.Id} updateOrder={this.updateOrder} />
    }
    let renderActionOpener = (opener) => {
      const onClick = (e) => {
        this.props.clearLastVisitedOrderId()
        opener(e)
      }
      return (
        <span onClick={onClick}>
          {icon}
        </span>
      )
    }
    let openClick = (open) => {
    }
    return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} openClick={openClick} checkForPopups={this.props.checkForPopups} />
  }

  renderColor (colorItem) {
    let image = 'Color-no-info-grey-VS.svg'
    let openImg = null
    let showBubbleText = translation('13603')

    if (hasAccess([4], this.props.auth.user.UserType)) {
      if (colorItem.ColorCode !== null && colorItem.ColorCode !== '') {
        image = 'Color_code.svg'
        showBubbleText = translation('79')
      } else if (colorItem.Color !== null && colorItem.Color !== '') {
        image = 'Color.svg'
        showBubbleText = translation('179')
      }
    } else {
      if (colorItem.ColorIsReady) {
        image = 'Color-ok.svg'
        showBubbleText = translation('13393')
      } else if (colorItem.ColorVariant !== null && colorItem.ColorVariant !== '') {
        image = 'color-variation.svg'
        showBubbleText = translation('13388')
      } else if (colorItem.ColorCode !== null && colorItem.ColorCode !== '') {
        image = 'Color_code.svg'
        showBubbleText = translation('79')
      } else if (colorItem.Color !== null && colorItem.Color !== '') {
        image = 'Color.svg'
        showBubbleText = translation('179')
      }
    }

    openImg = (
      <div className='hint--left' aria-label={showBubbleText}>
        <img src={'/images/svgs/color/' + image} className='icon hasCursor' />
      </div>
    )
    if (image === null) {
      return (
        <span>
          <div className='icon' />
        </span>
      )
    } else {
      // Overlay
      let renderActionMenu = () => {
        return <Color id={colorItem.Id} item={colorItem} updateOrder={this.updateOrder} checkForPopups={this.props.checkForPopups} />
      }
      let renderActionOpener = (opener) => {
        const onClick = (e) => {
          this.props.clearLastVisitedOrderId()
          opener(e)
        }
        return (
          <span onClick={onClick}>
            {openImg}
          </span>
        )
      }
      return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} checkForPopups={this.props.checkForPopups} />
    }
  }

  openAssign (type) {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    if (!hasAccessToAssign(this.props.auth)) return null
    if (type) {
      EventEmitter.emit('OPEN_ASSIGNBOX')
      this.getAssignOrderData()
    }
    this.setState({
      assign_open: type
    })
    this.props.toggleAssign(type)
  }

  getAssignOrderData (activeEmployees) {
    // Get assign order data
    this.props.getOrderDataNew({
      OrderIds: [this.state.item.Id],
      UserIds: activeEmployees || this.props.activeEmployees
    })
  }

  onAssignUsers () {
    this.refs.AssignBox.getWrappedInstance().getAssignEmployees()
    let searchData = {
      SimpleSearch: this.state.item.Id + '',
      SkipCheck: true
    }
    this.props.getOrdersNew(searchData).then((res) => {
      let order = res.data[0].Steps[this.props.step].Orders[0]
      this.updateOrder(order)
    })
  }

  unlockOrder () {
    let data = {
      dataset: {
        action: 'stopLockOrder'
      }
    }
    this.refs.OrderActions.getWrappedInstance().handleClick(data)
  }

  startOrderSuccess (data) {
    this.props.triggerPopup(false)
    this.setState({
      stopOtherOrders: {
        ...this.state.stopOtherOrders,
        WorkOnAll: null
      }
    })

    let item = { ...this.state.item }
    item.IsStarted = true
    item.IsCurrentUserWorking = true
    item.PreviouslyStarted = true
    this.setState({
      item: item
    })
    if (typeof this.props.startOrderSuccess !== 'undefined') {
      this.props.startOrderSuccess(item)
    }
  }

  startOrder () {
    if (hasAccess([5, 7], this.props.auth.user.UserType)) {
      if (typeof this.props.onStartAsShopLogin !== 'undefined') {
        let top = 500
        // let steps = document.getElementsByClassName('drag-content scrollbar')
        // for (let i = 0; i < steps.length; i++) {
        //   if (steps[i].dataset.pos === '' + this.props.step) {
        //     top = steps[i].scrollTop
        //   }
        // }

        this.props.onStartAsShopLogin({
          type: 'start',
          id: this.state.item.Id,
          scrollOffset: top,
          step: this.props.step
        })
        // this.props.setSelectedItem(this.state.item)
        return false
      }
    }

    let { item } = this.state
    let data = {
      Orders: [
        {
          OrderId: item.Id,
          WarrantyCode: null,
          PaintThickness: null
        }
      ],
      UserIds: [],
      WorkOnAll: this.state.stopOtherOrders.WorkOnAll,
      CheckOnly: false,
      ConfirmStart: true
    }

    this.props.startOrder(data).then((res) => {
      if (res.data.StopOtherOrders === true) {
        this.props.triggerPopup(true)
        this.setState({
          stopOtherOrders: {
            ...this.state.stopOtherOrders,
            open: true,
            WorkOnAll: null
          }
        })
      } else if ((res.data.length > 0 && this.stepHasFailedStartChecks(res.data)) || this.stepHasComments(res.data)) {     // if (res.data.length > 0 || this.stepHasComments(res.data)) {
        this.props.triggerPopup(true)
        this.setState({
          quality: {
            open: true,
            data: {
              res: res.data,
              WorkOnAll: this.state.stopOtherOrders.WorkOnAll,
              UserIds: []
            },
            move: false
          }
        })
      }
      // else {
      // window.toastr.success(translation('13518'), translation('13424'))
      this.startOrderSuccess(res.data[0])
      // }
    }, () => {
      window.toastr.error(translation('1923'), translation('216'))
    })
  }

  stopOrder () {
    if (hasAccess([5, 7], this.props.auth.user.UserType)) {
      if (typeof this.props.onStartAsShopLogin !== 'undefined') {
        this.props.onStartAsShopLogin({
          type: 'stop',
          id: this.state.item.Id
        })
        return false
      }
    }

    let { item } = this.state
    let data = {
      OrderId: item.Id,
      UserId: 0,
      StopAll: this.state.stopOrders.StopAll
    }

    this.props.stopOrder(data).then((res) => {
      if (res.data.StopAll === true) {
        this.props.triggerPopup(true)
        this.setState({
          stopOrders: {
            ...this.state.stopOrders,
            open: true,
            StopAll: null
          }
        })
      } else {
        let item = res.data
        this.setState({
          item: item
        })
        clearTimeout(this.updateTime)

        // let message = this.state.stopOrders.StopAll === true ? translation('12340') : translation('15042')
        // window.toastr.success(message, translation('13424'))

        this.setState({
          stopOrders: {
            ...this.state.stopOrders,
            StopAll: null
          }
        })
      }
    }, () => {
      let message = this.state.stopOrders.StopAll === true ? translation('12342') : translation('12343')
      window.toastr.error(message, translation('216'))
    })
  }

  AllOrders (type) {
    this.props.triggerPopup(false)
    if (type === 'stopOtherOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          WorkOnAll: true
        }
      }, () => {
        this.startOrder()
      })
    } else if (type === 'stopOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          StopAll: true
        }
      }, () => {
        this.stopOrder()
      })
    } else if (type === 'MoveOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          MoveAll: true
        }
      }, () => {
        this.moveOrders()
      })
    }
  }

  NotAllOrders (type) {
    this.props.triggerPopup(false)
    if (type === 'stopOtherOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          WorkOnAll: false
        }
      }, () => {
        this.startOrder()
      })
    } else if (type === 'stopOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          StopAll: false
        }
      }, () => {
        this.stopOrder()
      })
    } else if (type === 'MoveOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          MoveAll: false
        }
      }, () => {
        this.moveOrders()
      })
    }
  }

  setStopped () {
    this.setState({
      stopped: {
        ...this.state.stopped, open: true
      }
    })
    document.addEventListener('click', this.togglePortal, false)
  }

  renderCircle (circleItem) {
    // return this.renderWorkproviderPriceMatch()
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    let iswp = (hasAccess([6], this.props.auth.user.UserType))
    if (iswp || isCustomer || this.state.item.IsDraft) {
      if (!iswp && circleItem.IsStopped) {
        return <Circle onPopupOpen={this.props.clearLastVisitedOrderId} router={this.props.router} IsCustomer={isCustomer} item={circleItem} checkForPopups={this.props.checkForPopups} onStartAsShopLogin={this.props.onStartAsShopLogin} />
      }
    } else {
      return <Circle router={this.props.router}
        unlockOrder={this.unlockOrder}
        setStopped={this.setStopped}
        startOrder={this.startOrder}
        stopOrder={this.stopOrder}
        item={circleItem}
        updateOrder={this.updateOrder}
        onStartAsShopLogin={this.props.onStartAsShopLogin}
        moveOrders={this.moveOrders}
        openStartStopId={this.props.openStartStopId}
        hasOpendStatrStop={this.props.hasOpendStatrStop}
        onPopupOpen={this.props.clearLastVisitedOrderId} />
    }
    if (iswp) {
      return this.renderWorkproviderPriceMatch()
    }
  }

  renderWorkproviderPriceMatch () {
    let item = this.state.item
    // if (item.WpEconomicMatchType === null) return null
    let showCheckMark = true
    let handleClass = 'economic_pricematch'
    let perc = ''
    switch (item.WpEconomicMatchType) {
      case 0:
        if (item.WpEconomicMatchPerc !== null && item.WpEconomicMatchPerc !== 0) {
          // show percentage with Red color
          showCheckMark = false
          handleClass += ' unhandled'
          perc = item.WpEconomicMatchPerc + '%'
        } else {
          // show checked mark
          showCheckMark = true
          handleClass += ' unhandled'
        }
        break
      case 1:
        if (item.WpEconomicMatchPerc !== null && item.WpEconomicMatchPerc !== 0) {
          // show percentage with Green color
          showCheckMark = false
          handleClass += ' handled'
          perc = item.WpEconomicMatchPerc + '%'
        } else {
          // show checked mark
          showCheckMark = true
          handleClass += ' handled'
        }
        break
      case 2:
        showCheckMark = false
        handleClass += ' unhandled'
        perc = '-%'
        break
    }
    let renderInvoiceLog = () => {
      return (
        <InvoiceLog item={item} />
      )
    }
    if (item.WpEconomicMatchType === null) showCheckMark = false
    let renderActionOpener = (opener) => {
      const onClick = e => {
        this.props.clearLastVisitedOrderId()
        opener(e)
      }
      return (
        <div onClick={onClick} className={handleClass}>
          {showCheckMark && (<img src='/images/icons/Green_chekmark.png' />)}
          {!showCheckMark && perc}
          {item.WpEconomicMatchType === null && (<img src='/images/svgs/invoicelog/payment-notification.svg' />)}
        </div>
      )
    }
    return <Overlay renderActionMenu={renderInvoiceLog} renderActionOpener={renderActionOpener} checkForPopups={this.props.checkForPopups} />
  }

  renderPaintBodyStatus (item) {
    let paintLit = false
    let bodyLit = false

    let paintBooked = false
    let bodyBooked = false

    let paintOrdered = false
    let bodyOrdered = false

    let paintNotOrdered = false
    let bodyNotOrdered = false

    let paintTextItems = []
    let bodyTextItems = []
    let overallTextItems = []

    // Order shown as PaintShop, BodyShop or CombinedShop
    if (item.OrderDepartment === 0 || item.OrderDepartment === 1 || item.OrderDepartment === 2) {
      paintLit = item.IsPaintOrder
      paintBooked = !item.PaintIsDraft
      if (hasSubscriptionPermission(this.props.auth, 10)) {
        paintOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 8
        paintNotOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 1
      }
    }

    // Order shown as BodyShop or CombinedShop
    if (item.OrderDepartment === 1 || item.OrderDepartment === 2) {
      bodyLit = item.IsBodyShopOrder
      bodyBooked = !item.BodyShopIsDraft
      if (hasSubscriptionPermission(this.props.auth, 10)) {
        bodyOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 8
        bodyNotOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 1
      }
    }

    let image = 'show-work'
    let imageVert = 'show-work'
    let imgPath = '/images/svgs/orderlist/'

    // Check for paint/body work
    if (paintLit) {
      image += '_paint-lit'
      paintTextItems.push(translation('14829'))
    }
    if (bodyLit) {
      image += '_body-lit'
      bodyTextItems.push(translation('14830'))
    }

    if (paintLit && bodyLit) {
      overallTextItems.push(translation('14867'))
    }

    // Check for paint/body booked
    if (paintLit && !paintBooked) {
      image += '_paint-red'
      paintTextItems.push(translation('13045'))
    } else if (paintNotOrdered && !paintOrdered) {
      image += '_paint-red'
    } else if (hasSubscriptionPermission(this.props.auth, 10) && paintNotOrdered) {
      image += '_paint-red'
      // Check for paint/body spare parts ordered
    } else if (paintOrdered && !paintNotOrdered) {
      image += '_paint-yellow'
    }

    if (bodyLit && !bodyBooked) {
      image += '_body-red'
      bodyTextItems.push(translation('13046'))
    } else if (bodyLit && bodyBooked && bodyNotOrdered && !bodyOrdered) {
      image += '_body-red'
    } else if (bodyLit && hasSubscriptionPermission(this.props.auth, 10) && bodyNotOrdered) {
      image += '_body-red'
    }

    if (bodyLit && bodyBooked && bodyOrdered && !bodyNotOrdered) {
      image += '_body-yellow'
    }

    let imgClass = 'PaintBodyStatus flat'
    // if (!image.includes('red') && !image.includes('yellow')) {
    //   imgClass = ' PaintBodyStatus__padding'
    // }

    if (item.HasSpareParts === true && item.BodySparePartStatusSum !== 0 && hasSubscriptionPermission(this.props.auth, 10)) {
      // Body spare parts not ordered
      if (item.BodySparePartStatusSum === 1) {
        bodyTextItems.push(translation('13048'))
      }

      // Body spare parts not received
      if (item.BodySparePartStatusSum === 8) {
        bodyTextItems.push(translation('13050'))
      }

      // Body spare parts received
      if (item.BodySparePartStatusSum === 16) {
        bodyTextItems.push(translation('14870'))
      }
    }

    if (item.HasSpareParts === true && item.PaintSparePartStatusSum !== 0 && hasSubscriptionPermission(this.props.auth, 10)) {
      // Paint spare parts not ordered
      if (item.PaintSparePartStatusSum === 1) {
        if (bodyLit) {
          paintTextItems.push(translation('13047'))
        } else {
          paintTextItems.push(translation('638'))
        }
      }

      // Paint spare parts not received
      if (item.PaintSparePartStatusSum === 8) {
        if (bodyLit) {
          paintTextItems.push(translation('13049'))
        } else {
          paintTextItems.push(translation('639'))
        }
      }

      // Paint spare parts received
      if (item.PaintSparePartStatusSum === 16) {
        if (bodyLit) {
          paintTextItems.push(translation('14872'))
        } else {
          paintTextItems.push(translation('640'))
        }
      }
    }

    /*

    if (paintNotOrdered && !paintOrdered) {
      paintTextItems.push(translation('13047'))
    }
    if (bodyNotOrdered && !bodyOrdered) {
      bodyTextItems.push(translation('13048'))
    }
    if (paintOrdered && !paintNotOrdered) {
      paintTextItems.push(translation('13049'))
    }
    if (bodyOrdered && !bodyNotOrdered) {
      bodyTextItems.push(translation('13050'))
    }

    */
    imageVert = image + '-vertical'
    imageVert += '.svg'
    image += '.svg'

    let lines = []
    const hoverHoverTextLines = (val, key) => {
      if (key === 0) {
        if (lines.length > 0) {
          lines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()} />))
        }
      }
      lines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{val}</p>))
    }

    const addOverallText = (val, key) => {
      if (key !== 0) {
        overallTextItems.push(val)
      }
    }

    if (paintLit && bodyLit) {
      paintTextItems.map(addOverallText)
      bodyTextItems.map(addOverallText)

      overallTextItems.map(hoverHoverTextLines)
    } else {
      paintTextItems.map(hoverHoverTextLines)
      bodyTextItems.map(hoverHoverTextLines)
    }
    let useClick = true
    let useHover = true

    if (lines.length === 0) {
      lines = translation('14856')
    }

    return (
      <span className='fullSize orderStatus'>
        <div>
          <HoverPopup UseClick={useClick} UseHover={useHover} orderId={item.Id} getVerticalScrollOffset={this.getVerticalScrollOffset} getHorizontalScrollOffset={this.getHorizontalScrollOffset} scrollColumn={this.props.step} PopupContent={lines} >
            <img src={imgPath + image} className={imgClass} />
            <img src={imgPath + imageVert} className='PaintBodyStatus tall' />
          </HoverPopup>
        </div>
      </span>
    )
  }

  getVerticalScrollOffset () {
    let result = 0
    let scrollContainer = document.getElementById('app')
    if (scrollContainer !== undefined) {
      result = scrollContainer.scrollTop
    }
    return result
  }

  getHorizontalScrollOffset () {
    let result = 0
    let scrollContainer = document.getElementById('app')
    if (scrollContainer !== undefined) {
      result = scrollContainer.scrollLeft
    }

    return result
  }
  renderReferred (item) {
    if (!(item.IsReferredIn || item.IsReferredOut)) return null
    if (item.ReferredShopName === null || item.ReferredShopName === '') return null
    let transportImage = 'referred-order.svg'
    let renderActionMenu = () => {
      let renderTextOverlay = (text) => {
        return (
          <div className='poppedup padding transportpopup'>
            <label>{text}</label>
          </div>
        )
      }
      let referredText = translation('14757')
      referredText = referredText.replace('[Source]', item.ReferredShopName)
      referredText = referredText.replace('[Target]', item.ShopName)
      return renderTextOverlay(referredText)
    }
    let renderActionOpener = (opener) => {
      const onClick = e => {
        this.props.clearLastVisitedOrderId()
        opener(e)
      }
      let classname = ''
      return (
        <span onClick={onClick} className='icon hasTextInBubble'>
          <div className='hint--top'>
            <img src={'/images/svgs/transport/' + transportImage} className={classname} />
          </div>
        </span>
      )
    }
    return <Overlay className='referred' renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} checkForPopups={this.props.checkForPopups} />
  }
  renderTransport (transportItem) {
    if (this.props.auth.departmentType === 1) {
      if ((transportItem.BodyShopTransport === null || transportItem.BodyShopTransport === 0) && !transportItem.IsReferredOut) return <div className='icon' />
    } else {
      if (transportItem.Transport === null || transportItem.Transport === 0) return <div className='icon' />
    }
    // if pickup or delivery address is not normal address - Show bubble
    // if delivery address is not normal address - show bubble, but only in draft and new orders (step: 1)

    let isshop = hasAccess([3, 5, 7], this.props.auth.user.UserType)
    let showDifferentImageVar = false
    let transportImage = 'Can-drive-black.svg'
    let showDifferentImage = 'Can-drive-different-delivery-black.svg'
    let showBubbleText = translation('154')

    if (this.props.auth.departmentType === 1) {   // Bodyshop
      if (transportItem.IsReferredOut) {
        // transport not set and is referred out
        transportImage = 'referred-order.svg'
        showDifferentImage = 'referred-order.svg'
      }

      if (transportItem.BodyShopTransport === 3) {
        transportImage = 'Transport-black.svg'
        showDifferentImage = 'Transport-different-delivery-black.svg'
        showBubbleText = translation('26')
      }

      if (transportItem.BodyShopTransport === 2) {
        transportImage = 'loosepart_black.svg'
        showDifferentImage = 'loosepart_black_redcircle.svg'
        showBubbleText = translation('351')
      }

      // Check pickup location
      if ((transportItem.BodyShopPickupAltLocationId !== 0 || transportItem.BodyShopDeliveryAltLocationId !== 0) && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
        showBubbleText = translation('13418')
      }

      if ((transportItem.BodyShopPickupAltLocationId === 0 && transportItem.HasBodyShopPickupAltLocation) && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
        showBubbleText = translation('13418')
      }

      if (transportItem.BodyShopDeliveryAltLocationId !== 0 && transportItem.StepId >= 1) {
        showBubbleText = translation('13419')
      }

      if (transportItem.BodyShopDeliveryAltLocationId === 0 && transportItem.HasBodyShopDeliveryAltLocation && transportItem.StepId >= 1) {
        showBubbleText = translation('13419')
      }

      if (isshop && (transportItem.IsReferredIn || transportItem.IsReferredOut) && transportItem.BodyShopTransport !== null && transportItem.BodyShopTransport !== 0 && (transportItem.BodyShopPickupAltLocationId !== 0 || transportItem.BodyShopDeliveryAltLocationId !== 0)) {
        showDifferentImageVar = true
      }
    } else {  // Not bodyshop
      if (transportItem.Transport === 3) {
        transportImage = 'Transport-black.svg'
        showDifferentImage = 'Transport-different-delivery-black.svg'
        showBubbleText = translation('26')
      }

      if (transportItem.Transport === 2) {
        transportImage = 'loosepart_black.svg'
        showDifferentImage = 'loosepart_black_redcircle.svg'
        showBubbleText = translation('351')
      }

      // Check pickup location
      if ((transportItem.PickupAltLocationId !== 0 || transportItem.DeliveryAltLocationId !== 0) && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
        showDifferentImageVar = true
      }

      if (transportItem.DeliveryAltLocationId !== 0 && transportItem.StepId > 1) {
        showDifferentImageVar = true
      }
    }
    let classname = ''
    let iswp = hasAccess([6], this.props.auth.user.UserType)
    if (iswp) {
      if (transportItem.IsReferredIn) {
        showDifferentImageVar = true
        showDifferentImage = 'referred-order.svg'
        showBubbleText = ''
      } else {
        return null
      }
    }
    // if (!hasAccess([4], this.props.auth.user.UserType)) {
    //   classname = 'hasCursor'
    // }
    // Returns
    if (showDifferentImageVar) {
      let renderTextOverlay = (text) => {
        return (
          <div className='poppedup padding TransportInlinePopup'>
            <Label>{text}</Label>
          </div>
        )
      }

      // Overlay
      let renderActionMenu = () => {
        if (iswp && (transportItem.HasBodyShopPickupAltLocation && transportItem.BodyShopPickupAltLocationId === 0) || (transportItem.HasBodyShopDeliveryAltLocation && transportItem.BodyShopDeliveryAltLocationId === 0)) {
          if ((transportItem.HasBodyShopPickupAltLocation && transportItem.BodyShopPickupAltLocationId === 0) && (transportItem.StepId === 1 || transportItem.StepId === 8)) {
            return <Transport id={transportItem.Id} item={transportItem} updateOrder={this.updateOrder} />
          }
        } else {
          if (iswp && transportItem.IsReferredIn) {
            let referredText = translation('14757')
            referredText = referredText.replace('[Source]', transportItem.ReferredShopName)
            referredText = referredText.replace('[Target]', transportItem.ShopName)
            return renderTextOverlay(referredText)
          }
        }

        return <Transport id={transportItem.Id} item={transportItem} updateOrder={this.updateOrder} />
      }
      let renderActionOpener = (opener) => {
        const onClick = e => {
          this.props.clearLastVisitedOrderId()
          opener(e)
        }
        return (
          <span onClick={onClick} className='icon hasTextInBubble'>
            <div className='hint--top' aria-label={showBubbleText}>
              <img src={'/images/svgs/transport/' + showDifferentImage} className={classname} />
            </div>
            <span>!</span>
          </span>
        )
      }
      return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} checkForPopups={this.props.checkForPopups} />
    }
    let imageSrc = transportImage ? '/images/svgs/transport/' + transportImage : null
    return (
      <span className='icon hasTextInBubble' >
        <div className='hint--left' aria-label={showBubbleText}>
          <img src={imageSrc} className={classname} />
        </div>
      </span>
    )
  }

  renderPartWithoutPrice (partnopriceitem) {
    if (!partnopriceitem.HasTasksWithoutPrice) return <div className='icon' />
    let icon = (
      <span className='hasTextInBubble'>
        <img src={'/images/svgs/invoice/Payment-notification-icon.svg'} className='' />
        <span>?</span>
      </span>
    )
    if (hasAccess([4], this.props.auth.user.UserType)) {
      return (
        <span className='icon hint--left'>
          <div className='hint--left' aria-label={translation('12348')}>
            {icon}
          </div>
        </span>
      )
    }
    if (this.props.auth.departmentType === 1) {
      return (
        <span className='icon hint--left'>
          <div className='hint--left' aria-label={translation('12348')}>
            {icon}
          </div>
        </span>
      )
    }
    return (
      <span className='icon hasCursor'>
        <HoverExtent router={this.props.router} id={this.state.item.Id} item={this.state.item} checkForPopups={this.props.checkForPopups} >
          <div className='hint--left' aria-label={translation('14719')} onClick={() => this.props.router.push('/pricecalculation/' + partnopriceitem.Id + '/1')}>
            {icon}
          </div>
        </HoverExtent>
      </span>
    )
  }

  renderPrice (priceitem) {
    // let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    // if (isCustomer) {
    //   return (
    //     <span>{formatCurrency(priceitem.TotalPrice)}</span>
    //   )
    // } else {
    // Overlay
    let isshop = hasAccess([3, 5, 6, 7], this.props.auth.user.UserType)

    let renderActionMenu = (close) => {
      if (isshop && this.props.auth.departmentType !== 1 && hasSubscriptionPermission(this.props.auth, 20)) return <InvoiceLog item={priceitem} />
      return <PriceChange id={priceitem.Id} item={priceitem} updateOrder={this.updateOrder} close={close} />
    }
    let renderActionOpener = (opener) => {
      const onClick = e => {
        this.props.clearLastVisitedOrderId()
        opener(e)
      }
      return (
        <span onClick={onClick}>
          {formatCurrency(priceitem.TotalPrice)}
        </span>
      )
    }
    return <Overlay renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener} checkForPopups={this.props.checkForPopups} />
    // }
  }

  openReferenceApprove () {
    this.props.triggerPopup(true)
    this.setState({
      orderReferenceApprove: {
        open: true,
        id: this.state.item.id
      }
    })
  }

  renderTaksering (taksitem) {
    const update = () => {
      this.updateOrder(taksitem)
    }
    return <Taksering onPopupOpen={this.props.clearLastVisitedOrderId} router={this.props.router} item={taksitem} updateOrder={update.bind(this)} openReferenceApprove={this.openReferenceApprove.bind(this)} checkForPopups={this.props.checkForPopups} />
  }

  updateOrder (data) {
    // let orders = JSON.parse(JSON.stringify(this.props.orders))
    // orders[this.props.step].Orders[this.props.index] = data
    // this.props.updateOrderList(orders)
    this.props.updateOrderListSingle(data, this.props.step, this.props.index)
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
    this.props.triggerPopup(false)
  }

  renderLinkedOrders (item) {
    if (item === undefined) item = this.state.item

    if (item.LinkedOrders === undefined || item.LinkedOrders.length === 0) return null
    if (item.LinkedOrders.length !== 0) {
      return item.LinkedOrders.map(this.renderLinkedItem)
    }
  }
  renderRekvNr (partItem) {
    return (
      <div>
        <div className='text form'>
          <ChangeRekvNumber id={partItem.Id} item={partItem} updateOrder={this.updateOrder} showLabel='false' checkForPopups={this.props.checkForPopups} />
        </div>
        <div className='icon'>
          {this.renderShowInvoice(partItem)}
        </div>
      </div>
    )
  }

  getOrderTitle (item) {
    if (!hasAccess([6], this.props.auth.user.UserType)) {
      let titleClass = 'mobiletitle'
      if (hasAccess([4], this.props.auth.user.UserType)) {
        titleClass += ' customer'
      }
      if (this.props.auth.departmentType === 1) {
        if (item.HasCarRental) {
          titleClass += ' small'
        }
        let brandAndModel = ''
        if (item.BrandName) {
          if (item.BrandName.Name !== '2000') {
            brandAndModel += translation(item.BrandName.Name.toUpperCase())
          }
        }
        if (item.Model) brandAndModel += ' ' + item.Model.toUpperCase()
        return (
          <span className={titleClass}>
            <ul>
              {item.RegNumber && (<li>{item.RegNumber.toUpperCase()}</li>)}
              {brandAndModel !== '' && <li>{brandAndModel}</li>}
              {!item.RegNumber && !item.Model && (<li>{item.Id}</li>)}
            </ul>
          </span>
        )
      } else {
        return (
          <span className={titleClass}>
            <ul>
              {item.RegNumber && (<li>{item.RegNumber.toUpperCase()}</li>)}
              {item.Model && (<li>{item.Model.toUpperCase()}</li>)}
              {!item.RegNumber && !item.Model && (<li>{item.Id}</li>)}
            </ul>
          </span>
        )
        // return (
        //   <div className='mobiletitle'>
        //     {item.RegNumber && (<span>{item.RegNumber.toUpperCase()}</span>)}
        //     {item.Model && (<span>{item.Model.toUpperCase()}</span>)}
        //     {!item.RegNumber && !item.Model && (<span>{item.Id}</span>)}
        //   </div>
        // )
      }
    } else {
      return (
        <span className='mobiletitle wp'>
          <ul>
            <li className='wp'>{makeOrderTitle(item, translation, enumtranslate, true)}</li>
            <li className='orderid'>{'(' + item.Id + ')'}</li>
          </ul>
        </span>
      )
    }
  }

  getOrderHasRentalCar (item, active = false, isCustomer) {
    if (item.HasCarRental === true || item.HasRequestedCarRental === true) {
      // return if CarRentalAssignments only contains alternative.
      if (item.CarRentalAssignments.length > 0 && !item.HasCarRentalNotAlternative) return

      let image = ''
      let whatClasses = ''
      const hasNoCarSelected = item.HasRequestedCarRental && item.CarRentalAssignments.length === 0

      if (isCustomer) {
        image = '/images/svgs/ordrer/lend.svg'
        return (
          <div className='hoverinfoclass'>
            <div className='rentalCarImage'>
              <img src={image} style={{ width: 25, height: 25 }} />
            </div>
          </div>
        )
      }
      if (active === true) {
        image = '/images/svgs/ordrer/lend-cirkel-white.svg'
        switch (item.CarRentalColliderType) {
          case 0:
            image = '/images/svgs/ordrer/lend-cirkel-white.svg'
            break
          case 1:
            // image = '/images/svgs/ordrer/lend-yellowcircle-white.svg'
            break
          case 2:
            // image = '/images/svgs/ordrer/lend-redcircle-white.svg'
            break
        }
        whatClasses = 'rentCarActive'
      } else {
        image = '/images/svgs/ordrer/lend-cirkel.svg'
        switch (item.CarRentalColliderType) {
          case 0:
            image = '/images/svgs/ordrer/lend-cirkel.svg'
            break
          case 1:
            image = '/images/svgs/ordrer/lend-yellowcircle.svg'
            break
          case 2:
            image = '/images/svgs/ordrer/lend-redcircle.svg'
            break
        }
        whatClasses = 'rentCarKladde'

        if (hasNoCarSelected) {
          image = '/images/svgs/ordrer/lend-redcircle.svg'
        }
      }

      let hoverLines = []
      let useClick = true
      let useHover = true

      let carRentalAssignments = item.CarRentalAssignments
      if (carRentalAssignments.length > 0) {
        carRentalAssignments.forEach((elem, i) => {
          hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{elem.Identity}</p>))
          hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(elem.Start, true)}</p>))
          hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(elem.End, true)}</p>))
          if (i < carRentalAssignments.length - 1) {
            hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()} />))
          }
        })
      } else {
        hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(item.BodyShopPickupTime, true)}</p>))
        hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(item.BodyShopDeliveryTime, true)}</p>))
      }

      let number = 0

      if (carRentalAssignments.length > 0) {
        number = carRentalAssignments[0].CarNumber
      }
      if (item.HasCarRental && !item.CurrentShopCanAssignRentalCar) {  // Hide rental car number for car from other company.
        number = ''
        image = '/images/svgs/ordrer/lend.svg'
      }

      return (
        <HoverPopup UseClick={useClick} UseHover={useHover} orderId={item.Id} getVerticalScrollOffset={this.getVerticalScrollOffset} getHorizontalScrollOffset={this.getHorizontalScrollOffset} scrollColumn={this.props.step} PopupContent={hoverLines}>
          <div className='rentalCarImage'>
            <img src={image} style={{ width: 25, height: 25 }} />
            {!hasNoCarSelected && (
              <font className={whatClasses}>
                {number}
              </font>
            )}
          </div>
        </HoverPopup>
      )
    }
  }
  renderLinkedItem (item) {
    return this.renderItem(item, true)
  }
  renderItem (item, isLinked) {
    if (item === null || item.IsDeleted) return null
    // Generate title
    // let title = makeOrderTitle(this.state.item, translation, enumtranslate, true)
    let isBodyShop = this.props.auth.user.DepartmentType > 0
    let moreInfo = item.ShopName
    if (item.PriceModelName !== null && item.PriceModelName !== '') {
      moreInfo += ' (' + item.PriceModelName + ')'
    }
    // Generate link
    let link = hasSubscriptionPermission(this.props.auth, 0, 2) || hasSubscriptionPermission(this.props.auth, 0, 3) ? '/orders/' + item.Id : ''
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    let iswp = hasAccess([6], this.props.auth.user.UserType)
    let cols = iswp ? [0.7, 0.7, 0.7] : [0.7, 1]

    let shownCustomer = item.CustomerName
    if (this.props.auth.allowNoCustomer && item.CustomerSelect === 1) {
      shownCustomer = translation('15330')
    }

    let shownInsurance = ''
    if (hasSubscriptionPermission(this.props.auth, 10) && item.InsuranceCompanyId !== null && item.InsuranceCompanyId > 0) {
      shownInsurance = item.InsuranceCompanyName
    }
    let hasInsurance = shownInsurance !== ''
    let amActive = false

    if (item.IsStarted) {
      amActive = true
    }
    let isDuplicate = item.OrderKey !== undefined && item.OrderKey !== null && item.OrderKey.endsWith('_LoosePart')

    let wide = iswp ? ' wide' : ''
    let shownName = item.ReferredShopName
    let baseClass = ''
    let nameClass = 'ins'
    let hasReferred = shownName != null && shownName.length > 0
    let hasReferredOut = item.IsReferredOut
    let hasReferredIn = item.IsReferredIn
    if (hasReferred) {
      nameClass = 'refshop'
      baseClass += 'refshop'
    }
    let refshopclass = 'refshopclass'
    if (hasReferred && (!hasInsurance && !hasReferredOut) || !hasReferredIn) refshopclass = 'refshop'
    let bodyclass = ''
    if (!hasReferred && hasInsurance) baseClass = 'ins'
    if (this.props.auth.departmentType !== 0) bodyclass = ' body'
    if (hasReferred && hasReferredIn && (hasInsurance || hasReferredOut)) baseClass = 'fifteen'
    if (iswp) {
      baseClass = 'fifteen'
      bodyclass = ' wp'
    }
    if (baseClass !== '' && baseClass !== 'ins' && baseClass !== 'refshop') {
      refshopclass += ' ' + baseClass
      nameClass += ' ' + baseClass
    }
    let customerClass = 'mobilecustomer'
    if (iswp) customerClass += ' wp'
    if (item.HasCarRental) customerClass += ' rent'
    let outerclass = 'neworder_item-outer'
    if (isLinked) outerclass += ' linkedOrder'

    let innerClass = 'neworder_item clearfix'
    if (item.IsStarted && !isCustomer) innerClass += ' active'
    if (this.props.lastVisitedOrderId === item.Id) innerClass += ' lastVisitedOrder'

    if (item.IsDraft === true) {
      return (
        <div key={this.props.key + '' + item.Id}>
          <div id={'' + item.Id} className={outerclass} >
            <div className={innerClass}>
              <div className={'name mobilename' + bodyclass}>
                <HoverExtent router={this.props.router} id={item.Id} item={item} checkForPopups={this.props.checkForPopups}>
                  <Link to={link}>
                    <span className='hint--right' aria-label={translation(enumtranslate('OrderTypes', item.OrderType))}>
                      <img src={makeOrderTypeImage(item.OrderType, item.IsStarted && !isCustomer)} />
                    </span>
                    {this.getOrderTitle(item)}
                    {!iswp && this.props.auth.user.CustomerId === '-1' && (
                      <div className={customerClass}>
                        <ul>
                          <li className={baseClass}>{shownCustomer}</li>
                          {hasInsurance && <li className={nameClass}>{shownInsurance}</li>}
                          {hasReferred && <li className={refshopclass}>{shownName}</li>}
                        </ul>
                      </div>
                    )}
                    {iswp && (
                      <div className={customerClass}>
                        <ul>
                          <li className={baseClass}>{shownCustomer}</li>
                          <li className={nameClass}>{moreInfo}</li>
                          {hasReferred && <li className={refshopclass}>{shownName}</li>}
                        </ul>
                      </div>
                    )}
                    {this.getOrderHasRentalCar(item, amActive, isCustomer)}
                  </Link>
                </HoverExtent>
              </div>
              <div className={'rightorder mobileright' + bodyclass}>
                {(isBodyShop || hasSubscriptionPermission(this.props.auth, 10)) && <div className='divider hide_small' />}
                <div className='rekv_nr'>
                  {this.renderReferred(item)}
                  {(isBodyShop || hasSubscriptionPermission(this.props.auth, 10)) && this.renderRekvNr(item)}
                </div>
                <div className='divider' />
                <div className='message_missing_color'>
                  {this.renderNotes(item)}
                  {!iswp && this.renderMissingPart(item)}
                  {!iswp && this.renderColor(item)}
                </div>
                <div className='divider' />
                {isCustomer || iswp ? (
                  <div className='times_wrap clearfix' style={{ textAlign: 'left', alignItems: 'left' }}>
                    <span aria-label={translation('13387')} className='timeCreated hint--top'>{renderFullDate(item.CreationDate, true)}</span>
                  </div>
                ) : ([
                  <div className='times_wrap clearfix' style={{ textAlign: 'left', alignItems: 'left' }}>
                    <Grid cols='.7fr 1fr'>
                      <span aria-label={translation('16458') + ' ' + renderFullDate(isBodyShop ? item.BodyShopPickupTime : item.Pickup, true)} className='timeCreated hint--top'>
                        {renderFullDate(isBodyShop ? item.BodyShopPickupTime : item.Pickup, false)}
                      </span>
                      <span aria-label={translation('193') + ' ' + renderFullDate(isBodyShop ? item.BodyShopDeliveryTime : item.Delivery, true)} className='timeCreated hint--top'>
                        {renderFullDate(isBodyShop ? item.BodyShopDeliveryTime : item.Delivery, true)}
                      </span>
                    </Grid>
                  </div>
                ])}
                {hasSubscriptionPermission(this.props.auth, 10) && <div className='divider hide_small' key='circle_1' />}
                {(!hasSubscriptionPermission(this.props.auth, 30) || !isLinked) && hasSubscriptionPermission(this.props.auth, 10) && (
                <div className='circle' key='circle_2'>
                    {this.renderCircle(item)}
                  </div>)}
                {hasSubscriptionPermission(this.props.auth, 30) && isLinked && (
                  <div className='circle hint--left' aria-label={translation('13525')} key='circle_2'>
                    <img src='/images/svgs/workscreen/link-order.svg' style={{ width: 25, height: 25 }} />
                  </div>)}
                {(!hasSubscriptionPermission(this.props.auth, 20) && !isBodyShop) && <div className='circle' key='circle_2' />}
                {this.props.auth.departmentType !== 0 && (
                  <span>
                    <div className='divider' />
                    <div className='body_paint_status'>
                      {this.renderPaintBodyStatus(item)}
                    </div>
                  </span>
                )}
                <div className='divider' />
                {!iswp && (<div className='transport'>
                  {this.renderTransport(item)}
                  {!iswp && this.renderPartWithoutPrice(item)}
                  {!iswp && this.renderTaksering(item)}
                </div>)}
                {iswp && (<div className='transport'>
                  {this.renderTransport(item)}
                  {this.renderTaksering(item)}
                </div>)}
                {!isCustomer && (
                  this.renderInvoice(item)
                )}
                <div className='divider' />
                <div className={'price_and_action' + bodyclass}>
                  {this.renderPrice(item)}
                  <OrderActions router={this.props.router} ref='OrderActions' itemType='0' item={item} type='orderlist' index={this.props.index} step={this.props.step} onOrderMove={this.moveOrder.bind(this)} deleteOrderIndex={this.deleteOrderIndex.bind(this)} />
                </div>
              </div>
            </div>
            {this.state.assign_open && (
              <AssignBox router={this.props.router} ref='AssignBox' closeAssign={() => { this.openAssign(false) }} onEmployeeChange={this.getAssignOrderData} />
            )}
            { /* item.NeedReferredApprove && */ this.state.orderReferenceApprove.open && (
              <ReferenceOrderActionModal
                show={this.state.orderReferenceApprove.open}
                item={item}
                id={item.Id}
                onClose={this.onPortalClose.bind(this, 'orderReferenceApprove')}
                checkForPopups={this.props.checkForPopups}
                department={this.props.auth.departmentType} />
            )}
          </div>
          {!isLinked && this.renderLinkedOrders()}
        </div>

      )
    } else {
      return (
        <div key={this.props.key + '' + item.Id}>
          <div id={'' + item.Id} className={outerclass}>
            <div className={innerClass}>
              <div className={'name mobilename' + wide + bodyclass}>
                <HoverExtent router={this.props.router} id={item.Id} item={item} checkForPopups={this.props.checkForPopups} >
                  <Link to={link}>
                    <span className='hint--right' aria-label={translation(enumtranslate('OrderTypes', item.OrderType))}>
                      <img src={makeOrderTypeImage(item.OrderType, item.IsStarted && !isCustomer)} />
                    </span>
                    {this.getOrderTitle(item)}
                    {isCustomer && hasReferred && (
                      <div className={customerClass}>
                        <ul>
                          <li className={refshopclass}>{shownName}</li>
                        </ul>
                      </div>
                    )}
                    {!iswp && this.props.auth.user.CustomerId === '-1' && !hasReferredOut && (
                      <div className={customerClass}>
                        <ul>
                          <li className={baseClass}>{shownCustomer}</li>
                          {hasInsurance && <li className={nameClass}>{shownInsurance}</li>}
                          {hasReferred && <li className={refshopclass}>{item.ShopNameReferredFrom}</li>}
                        </ul>
                      </div>
                    )}
                    {iswp && (
                      <div className={customerClass}>
                        <ul>
                          <li className={baseClass}>{shownCustomer}</li>
                          <li className={nameClass}>{moreInfo}</li>
                          {hasReferred && <li className={refshopclass}>{shownName}</li>}
                        </ul>
                      </div>
                    )}
                    {hasReferred && hasReferredOut && !iswp && this.props.auth.user.CustomerId === '-1' && (
                      <div className={customerClass}>
                        <ul>
                          <li className={baseClass}>{shownCustomer}</li>
                          {item.IsReferredIn && <li className={nameClass}>{item.ShopNameReferredFrom}</li>}
                          <li className={refshopclass}>{item.ShopNameReferredTo}</li>
                        </ul>
                      </div>
                    )}
                    {this.getOrderHasRentalCar(item, amActive, isCustomer)}
                  </Link>
                </HoverExtent>
              </div>
              <div className={'rightorder mobileright' + wide + bodyclass}>
                {(isBodyShop || hasSubscriptionPermission(this.props.auth, 10)) && <div className='divider' />}
                <div className='rekv_nr'>
                  {this.renderReferred(item)}
                  {(isBodyShop || hasSubscriptionPermission(this.props.auth, 10)) && this.renderRekvNr(item)}
                </div>
                <div className='divider' />
                <div className='message_missing_color'>
                  {this.renderNotes(item)}
                  {!iswp && this.renderMissingPart(item)}
                  {!iswp && this.renderColor(item)}
                </div>
                <div className='divider' />
                {!hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.departmentType === 0 && item.Step !== 8 && (
                  <div className='times_wrap clearfix' style={{ textAlign: 'left', alignItems: 'left' }}>
                    <span aria-label={translation('13012')} className='timeCreated hint--top'>{renderFullDate(item.PublishDate, true)}</span>
                  </div>
                )}
                {!hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.departmentType === 0 && item.Step === 8 && (
                  <div className='times_wrap clearfix' style={{ textAlign: 'left', alignItems: 'left' }}>
                    <span className='hint--top hasDefaultCursor timeCreated' aria-label={translation('1231') + ' ' + renderFullDate(item.ArchiveDate) || '\u00a0'}>
                      {renderFullDate(item.ArchiveDate, false) || '\u00a0'}
                    </span>
                  </div>
                )}
                {!(!hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.departmentType === 0) && (
                  <div className='times_wrap clearfix'>
                    <Grid cols={cols}>
                      {iswp && (
                        <span className='times'>
                          {renderFullDate(item.CreationDate, false) || '\u00a0'}
                        </span>)}
                      {this.renderNewOrder(item)}
                      {this.renderHandover(item)}
                    </Grid>
                  </div>
                )}
                {hasSubscriptionPermission(this.props.auth, 10) && <div className='divider hide_small' key='circle_1' />}
                {(!hasSubscriptionPermission(this.props.auth, 30) || !isLinked) && hasSubscriptionPermission(this.props.auth, 10) && (
                  <div className='circle' key='circle_2'>
                    {!isDuplicate && this.renderCircle(item)}
                  </div>)}
                {hasSubscriptionPermission(this.props.auth, 30) && isLinked && (
                  <div className='circle hint--left' aria-label={translation('13525')} key='circle_2'>
                    <img src='/images/svgs/workscreen/link-order.svg' style={{ width: 25, height: 25 }} />
                  </div>)}
                {!hasSubscriptionPermission(this.props.auth, 20) && !isBodyShop && <div className='circle' key='circle_2' />}
                {this.props.auth.departmentType !== 0 && (
                  <span>
                    <div className='divider' />
                    <div className='body_paint_status'>
                      {this.renderPaintBodyStatus(item)}
                    </div>
                  </span>
                )}
                <div className='divider' />
                {!iswp && (<div className='transport'>
                  {this.renderTransport(item)}
                  {!iswp && this.renderPartWithoutPrice(item)}
                  {!iswp && this.renderTaksering(item)}
                </div>)}
                {iswp && (<div className='transport'>
                  {this.renderTransport(item)}
                  {this.renderTaksering(item)}
                </div>)}
                <div className='divider' />
                {!isCustomer && this.renderInvoice(item)}
                <div className='divider' />
                <div className={'price_and_action' + bodyclass}>
                  {this.state.assign_open && (
                    <Popup item={item} onAssignUsers={this.onAssignUsers} />
                  )}
                  {this.renderPrice(item)}
                  <OrderActions router={this.props.router} ref='OrderActions' itemType='0' item={item} type='orderlist' index={this.props.index} step={this.props.step} onOrderMove={this.moveOrder.bind(this)} deleteOrderIndex={this.deleteOrderIndex.bind(this)} checkForPopups={this.props.checkForPopups} triggerClickAssign={this.triggerClickAssign} />
                </div>
              </div>
              {this.state.assign_open && (
                <AssignBox router={this.props.router} ref='AssignBox' closeAssign={() => { this.openAssign(false) }} onEmployeeChange={this.getAssignOrderData} />
              )}
              { /* item.NeedReferredApprove && */ this.state.orderReferenceApprove.open && (
                <ReferenceOrderActionModal
                  show={this.state.orderReferenceApprove.open}
                  item={item}
                  id={item.Id}
                  onClose={this.onPortalClose.bind(this, 'orderReferenceApprove')}
                  checkForPopups={this.props.checkForPopups}
                  department={this.props.auth.departmentType} />
              )}
              {this.state.quality.open && (
                <QualityCheckModal router={this.props.router}
                  show={this.state.quality.open}
                  data={this.state.quality.data}
                  onSuccess={this.startOrderSuccess}
                  onMoveSuccess={this.closeQualityModal}
                  onClose={this.closeQualityModal}
                  move={this.state.quality.move}
                  checkForPopups={this.props.checkForPopups} />
              )}
              {this.state.stopOtherOrders.open && (
                <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'stopOtherOrders')}>
                  <StopOtherOrders Stop={false} AllOrders={this.AllOrders.bind(this, 'stopOtherOrders')} NotAllOrders={this.NotAllOrders.bind(this, 'stopOtherOrders')} />
                </Portal>
              )}
              {this.state.stopOrders.open && (
                <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'stopOrders')}>
                  <StopOtherOrders Stop={this.state.stopOrders.open} AllOrders={this.AllOrders.bind(this, 'stopOrders')} NotAllOrders={this.NotAllOrders.bind(this, 'stopOrders')} />
                </Portal>
              )}
              {this.state.MoveOrders.open && (
                <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'MoveOrders')}>
                  <StopOtherOrders Move AllOrders={this.AllOrders.bind(this, 'MoveOrders')} NotAllOrders={this.NotAllOrders.bind(this, 'MoveOrders')} />
                </Portal>
              )}
            </div>
            {!isLinked && this.renderLinkedOrders()}
          </div>
        </div>
      )
    }
  }
  render () {
    return this.renderItem(this.state.item)
  }

  closeQualityModal () {
    this.setState({
      quality: {
        open: false,
        data: {},
        index: 0,
        pos: 0
      }
    })
    this.props.triggerPopup(false)
  }

  moveOrders (data) {
    if (data === undefined) {
      data = {
        OrderIds: this.state.MoveOrders.MoveAll === true ? this.state.MoveOrders.OrderIds : [this.state.MoveOrders.Id],
        UserId: 0,
        StepFrom: this.state.MoveOrders.FromStep,
        StepTo: this.state.MoveOrders.ToStep,
        Comment: '',
        FilterSettings: {}
      }
      this.setState({
        MoveOrders: {
          ...this.state.MoveOrders,
          MoveAll: null
        }
      })
    }

    let orders = []
    for (let i = 0; i < data.OrderIds.length; i++) {
      let order = {
        OrderId: data.OrderIds[i]
      }
      orders.push(order)
    }

    let moveData = {
      Orders: orders,
      UserId: data.UserId,
      StepFrom: data.StepFrom,
      StepTo: data.StepTo,
      Comment: data.Comment,
      FilterSettings: data.FilterSettings,
      MoveAll: data.MoveAll === undefined ? this.state.MoveOrders.MoveAll : data.MoveAll,
      CheckOnly: false
    }

    this.props.moveOrder(moveData).then((res) => {
      if (res.data.MoveAll) {
        this.setState({
          MoveOrders: {
            ...this.state.MoveOrders,
            open: true,
            MoveAll: null,
            OrderIds: res.data.OrderIds,
            FromStep: moveData.StepFrom, // res.data.StepFrom,
            ToStep: moveData.StepTo, // res.data.StepTo,
            Id: data.OrderIds[0]
          }
        }, () => {
          return null
        })
      } else if (res.data.Checks.length > 0) {
        this.props.triggerPopup(true)
        res.data.OrderIds = data.OrderIds
        this.setState({
          quality: {
            open: true,
            data: [res.data],
            pos: data.Pos,
            index: data.Index,
            move: true
          },
          MoveOrders: {
            ...this.state.MoveOrders,
            FromStep: moveData.StepFrom
          }
        })
      } else {
        if (this.stepHasComments(res.data)) {
          this.props.triggerPopup(true)
          this.setState({
            quality: {
              open: true,
              data: [res.data],
              pos: data.Pos,
              index: data.Index,
              move: true
            }
          })
        } else {
          // let message = orders.length > 1 ? translation('12338') : translation('1909')
          // window.toastr.success(message, translation('13424'))
          // if (res.data.MoveFailed === false) {
          //   this.moveOrderSuccess(res.data, moveData.Orders)
          // }
        }
        // this.updateRow(res.data.CurrentStepOrders, data.Pos, data.Index)
      }
    }, (res) => {
      // Toastr
      let message
      if (res.response.data.IsStopped === true) message = translation('12347')
      else if (res.response.data.IsReffered === true) message = translation('2704')
      else message = orders.length > 1 ? translation('12339') : translation('1731')

      // Get error message from response.
      if (res.response.data !== undefined && res.response.data.DictionaryKey !== undefined) {
        message = translation(res.response.data.DictionaryKey)
      }

      // If have StatusCode = 1 (Order can not be moved to this step)
      if (res.response.data !== undefined && res.response.data.StatusCode !== undefined) {
        let statusCode = res.response.data.StatusCode
        if (statusCode === 1) {
          // this.moveOrders(this.state.MoveOrders) // Made mass error message spam...
        }
      }

      window.toastr.error(message, translation('216'))
    })
  }

  moveOrder (data) {
    let orders = []
    for (let i = 0; i < data.OrderIds.length; i++) {
      let order = {
        OrderId: data.OrderIds[i]
      }
      orders.push(order)
    }

    let moveData = {
      Orders: orders,
      UserId: data.UserId,
      StepFrom: data.StepFrom,
      StepTo: data.StepTo,
      Comment: data.Comment,
      FilterSettings: data.FilterSettings,
      MoveAll: false,
      CheckOnly: false
    }

    this.props.moveOrder(moveData).then((res) => {
      if (res.data.Checks.length > 0) {
        this.props.triggerPopup(true)
        res.data.OrderIds = data.OrderIds
        this.setState({
          quality: {
            open: true,
            data: [res.data],
            pos: data.Pos,
            index: data.Index,
            move: true
          }
        })
      } else {
        if (this.stepHasComments(res.data)) {
          this.props.triggerPopup(true)
          this.setState({
            quality: {
              open: true,
              data: [res.data],
              pos: data.Pos,
              index: data.Index,
              move: true
            }
          })
        } else if (res.data.FrontendActions !== undefined && res.data.FrontendActions !== null && res.data.FrontendActions.length > 0) {
          // Handle additional actions directed by backend.
          // const NONE = 0
          // const CONFIRM_START = 1 // Not used here
          const GOTO_WORKCARD = 2

          const gotoWorkCard = (orderId) => {
            this.props.router.push('/orders/' + orderId + '?notifyPaintNotBooked=1')
          }
          if (res.data.FrontendActions !== undefined && res.data.FrontendActions !== null && res.data.FrontendActions.length > 0) {
            res.data.FrontendActions.forEach(item => {
              if (item.Action === GOTO_WORKCARD) {
                gotoWorkCard(item.OrderId)
              }
            })
          }
        } else if (!res.data.MoveFailed) {
          // window.toastr.success(translation('1909'), translation('13424'))
        }
      }
    }, (res) => {
      // Toastr
      let message
      if (res.response.data.IsStopped === true) message = translation('12347')
      else if (res.response.data.IsReffered === true) message = translation('2704')
      else message = translation('1731')
      window.toastr.error(message, translation('216'))
    })
  }

  stepHasComments (data) {
    let ProcessComments = data.ProcessComments
    let anyComments = false
    if (ProcessComments) {
      ProcessComments.map((val) => {
        if (val.StepComments.length !== 0) anyComments = true
      })
    } else if (data.Checks) {
      data.Checks.map((check) => {
        check.ProcessComments.map((val) => {
          if (val.StepComments.length !== 0) anyComments = true
        })
      })
    }

    return anyComments
  }

  stepHasFailedStartChecks (data) {
    // Because of old and messy "NewItem" code, that seriously needs refactoring (!) - the structure of the object that gets passed to this function is not reliable,
    // so need to check the structure for where 'QualityCheck' lives.
    // - 1. data might be array of orders that each hold the QualityCheck object.
    // - 2. data might be single order object that holds the QualityCheck object.
    // - 3. data might be object that holds a Checks array (refer to function 'stepHasComments' above) that holds QualityCheck object.
    let hasFailed = false
    if (Array.isArray(data) && data.some(x => x.QualityCheck && x.QualityCheck.StartFailed)) {
      hasFailed = true
    } else if (data.QualityCheck && data.QualityCheck.StartFailed) {
      hasFailed = true
    } else if (Array.isArray(data.Checks)) {
      data.Checks.map(x => {
        if (x.QualityCheck && x.QualityCheck.StartFailed) hasFailed = true
      })
    }
    return hasFailed
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    orders: state.orders.orders,
    activeEmployees: state.assign.activeEmployees,
    lastVisitedOrderId: state.orders.lastVisitedOrderId
  }
}

export default connect(mapStateToProps, {
  updateOrderList,
  updateOrderListSingle,
  getOrderDataNew,
  getOrderSimple,
  getOrdersNew,
  moveOrder,
  startOrder,
  stopOrder,
  triggerPopup,
  // approveOrderInvoice,
  UpdateEconomicMatch,
  updateRekvNumber,
  GetSimpleCarRentals,
  clearLastVisitedOrderId
})(NewItem)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/index.js